import { confidenceDisplayRuleFor } from '../registry/customerInsightsConfidence';
import { CardConfidence } from '../types';
import { CardConfidenceInput, cardConfidenceFrom } from './cardConfidence';

/**
 * Customer Insights' binding of the shared card-confidence rule: the computation is
 * `data/cardConfidence.ts`, and the only thing this layer supplies is its own `Show Confidence
 * Score?` table (`registry/customerInsightsConfidence.ts`, the `O-*` catalogue).
 *
 * That table IS the isolation. `product_readiness`, `ready_for_engagement`, `contact_restrictions`
 * and `risk_unusual_activity` are card keys BOTH registries declare, so a Customer 360 identifier
 * reaching this function must contribute nothing: `confidenceDisplayRuleFor('C-COM-020')` is
 * `undefined`, which is not `'yes'`, so it is never eligible and never reaches the mean. PLA-8815.
 */
export const customerInsightsCardConfidence = (
  inputs: CardConfidenceInput[]
): CardConfidence | undefined => cardConfidenceFrom(confidenceDisplayRuleFor, inputs);

export type { CardConfidenceInput, ConfidenceReasonRule } from './cardConfidence';
export { CONFIDENCE_REASON_RULES, confidenceReasonRuleFor } from './cardConfidence';

export default customerInsightsCardConfidence;
